import * as React from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import Text from '../../components/Text/Text';
import FAQContent from './FAQContent';
import './FAQPage.css';

const FAQPage = React.memo(() => {
  const { t } = useTranslation('translation');

  return (
    <div className="PageShell FAQPage">
      <header className="PageHero">
        <div className="PageHero__glow" aria-hidden />
        <div className="PageHero__content">
          <span className="PageHero__eyebrow">
            <QuestionCircleOutlined /> FAQ
          </span>
          <Text size={6} bold>
            {t('faq_title')}
          </Text>
          <Text type="secondary" size={3}>
            Ответы на частые вопросы по статистике, режимам и интеграциям
          </Text>
        </div>
      </header>

      <section className="PageSection">
        <FAQContent />
      </section>
    </div>
  );
});

export default FAQPage;
